module.exports = __webpack_public_path__ + "static/img/img_logo.d23421cf.png";